import { setModel } from './util'
import * as utils from '@/utils'
import store from './store'
export default {
  name: 'BaseSearch',

  componentName: 'BaseSearch',

  inheritAttrs: false,

  provide () {
    return {
      search: this
    }
  },

  props: {
    trigger: {
      type: String,
      default: 'blur'
    },
    cache: Boolean
  },

  created () {
    store.$on('search', this.search)
    this.$on('$model', data => {
      this.$emit('update:model', data)
    })
  },

  beforeDestroy () {
    store.$off('search', this.search)
  },

  methods: {
    search () {
      const { model } = this.$attrs
      if (this.cache) setModel(this.$route, model)
      this.$emit('search', model)
    },
    reset () {
      this.$refs.form.resetFields()
      this.$emit('reset')
      utils.broadcast(this, 'BaseSelect', 'resetField')
      this.$nextTick(this.search)
    }
  },

  render (h) {
    const { trigger, $slots, $attrs } = this
    const children = $slots.default.map(child => {
      const { label, prop, rules, labelWidth, required, message } = Object.assign({}, child.componentOptions.propsData, child.data.attrs)
      const _required = [ { required: required !== undefined, message, trigger } ]
      const _rules = Array.isArray(rules) ? rules.some(item => item.required) ? rules : rules.concat(_required) : _required
      return <el-form-item
        label={label}
        prop={prop}
        rules={_rules}
        labelWidth={labelWidth}
      >{child}</el-form-item>
    })
    return <div class="mb-3 clearfix">
      <el-form { ...{ props: $attrs } } ref="form">
        {children}
        <span>
          <el-button type="primary" plain onClick={this.search}>确定</el-button>
          <el-button type="default" plain onClick={this.reset}>重置</el-button>
          {$slots.append}
        </span>
      </el-form>
    </div>
  }
}
